<template>
  <div class="addBankCard">
    <div class="container">
      <!-- 头部 -->
      <header class="header">
        <div class="header-content">
          <div class="left" @click="changego">
            <van-icon name="arrow-left" color="#fff" size="20px" />
          </div>
          <div class="title">添加银行卡</div>
          <div class="right"></div>
        </div>
      </header>

      <!-- 表单内容 -->
      <div class="form-container">
        <!-- 银行选择 -->
        <div class="form-item">
          <div class="label">银行</div>
          <div class="input-wrapper">
            <select 
              v-model="selectedBank" 
              class="form-input bank-select"
            >
              <option value="">请选择银行</option>
              <option v-for="bank in bankList" :key="bank" :value="bank">{{ bank }}</option>
            </select>
          </div>
        </div>

        <!-- 支行 -->
        <div class="form-item">
          <div class="label">支行</div>
          <div class="input-wrapper">
            <input 
              type="text" 
              v-model="branchName" 
              placeholder="请输入支行名称" 
              class="form-input"
            />
          </div>
        </div>

        <!-- 姓名 -->
        <div class="form-item">
          <div class="label">姓名</div>
          <div class="input-wrapper">
            <input 
              type="text" 
              v-model="realName" 
              placeholder="请输入与银行卡相匹配的真实姓名" 
              class="form-input"
            />
          </div>
        </div>

        <!-- 卡号 -->
        <div class="form-item">
          <div class="label">卡号</div>
          <div class="input-wrapper">
            <input 
              type="text" 
              v-model="cardNumber" 
              placeholder="请15-20位输入银行卡号" 
              class="form-input"
              maxlength="20"
            />
          </div>
        </div>

        <!-- 按钮区域 -->
        <div class="button-container">
          <button class="submit-btn" @click="btnSubmit">提交</button>
          <button class="my-cards-btn" @click="goToMyCards">我的银行卡</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userApi from "@/api/user";

export default {
  name: "addBankCard",
  data() {
    return {
      selectedBank: "",
      branchName: "",
      realName: "",
      cardNumber: "",
      type: 0,
      showBankPicker: false,
      bankList: [
        "中国工商银行",
        "中国建设银行", 
        "中国农业银行",
        "中国银行",
        "交通银行",
        "招商银行",
        "中信银行",
        "光大银行",
        "华夏银行",
        "民生银行",
        "广发银行",
        "平安银行",
        "浦发银行",
        "兴业银行",
        "邮储银行",
        "北京银行",
        "上海银行",
        "江苏银行",
        "宁波银行",
        "杭州银行"
      ]
    };
  },
  methods: {
    changego() {
      this.$router.go(-1);
    },

    goToMyCards() {
      // 跳转到我的银行卡页面
      this.$router.push('/newWithdraw');
    },
    btnSubmit() {
      if (!this.selectedBank) {
        this.$toast('请选择银行');
        return;
      }
      if (!this.branchName) {
        this.$toast('请输入支行名称');
        return;
      }
      if (!this.realName) {
        this.$toast('请输入与银行卡相匹配的真实姓名');
        return;
      }
      if (!this.cardNumber) {
        this.$toast('请15-20位输入银行卡号');
        return;
      }
      if (this.cardNumber.length < 15 || this.cardNumber.length > 20) {
        this.$toast('银行卡号长度应为15-20位');
        return;
      }

      let that = this;
      userApi.setPayInfo(this.realName, this.cardNumber, this.selectedBank, this.branchName, this.type).then((data) => {
        console.log(data.msg);
        this.$toast.loading({
          message: '添加成功',
          forbidClick: true,
          duration: 500,
          onClose() {
            that.$router.go(-1);
          },
        });
      }).catch((error) => {
        console.log('添加银行卡失败:', error);
        // 显示错误信息
        if (error && error.msg) {
          this.$toast(error.msg);
        } else {
          this.$toast('添加银行卡失败，请重试');
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.addBankCard {
  min-height: 100vh;
  background: #050925;
  color: #fff;
}

.container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.header {
  width: 100%;
  height: 1.31333rem;
  background: #161936;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  
  .header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    height: 100%;
    
    .left {
      width: 44px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .title {
      font-size: 18px;
      font-weight: 500;
      color: #fff;
    }
    
    .right {
      width: 44px;
    }
  }
}

.form-container {
  flex: 1;
  padding: 40px 30px 0;
  margin-top: 1.31333rem;
}

.form-item {
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  padding: 10px 0;
  min-height: 24px;
  
  .label {
    font-size: 16px;
    color: #fff;
    font-weight: 400;
    width: 60px;
    flex-shrink: 0;
  }
  
  .input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    background: transparent;
    flex: 1;
    
    .form-input {
      flex: 1;
      background: transparent;
      border: none;
      outline: none;
      color: #fff;
      font-size: 14px;
      padding: 0;
      line-height: 24px;
      
      &::placeholder {
        color: #666;
        font-size: 14px;
      }
    }
    
    .bank-select {
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      background: transparent url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8"><path fill="%23666" d="M6 8L0 2h12z"/></svg>') no-repeat right center;
      background-size: 12px 8px;
      padding-right: 20px;
      cursor: pointer;
    }
    
    .bank-select option {
      background: #161936;
      color: #fff;
    }
  }
}

.button-container {
  margin-top: 80px;
  padding: 0 0px 40px;
  
  .submit-btn {
    width: 100%;
    height: 50px;
    background: linear-gradient(90deg, #4A9EFF 0%, #1E88E5 100%);
    border: none;
    border-radius: 25px;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 20px;
    cursor: pointer;
    
    &:active {
      opacity: 0.8;
    }
  }
  
  .my-cards-btn {
    width: 100%;
    height: 50px;
    background: linear-gradient(90deg, #FF8A9B 0%, #FF6B7A 100%);
    border: none;
    border-radius: 25px;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    
    &:active {
      opacity: 0.8;
    }
  }
}
</style>